import React, { useEffect } from 'react';

function AboutPageNew() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div id="about-page-view" className="view-section min-h-screen py-32 px-10 md:px-20 bg-black transition-all duration-500">
      <div className="max-w-7xl mx-auto">
        {/* Page Title */}
        <div className="mb-20">
          <h2 className="bank-gothic text-xs tracking-[0.5em] text-neutral-500 mb-4 uppercase">ABOUT US</h2>
          <h3 className="bank-gothic text-4xl md:text-5xl">
            WHO WE <span className="accent-text">ARE</span>
          </h3>
        </div>

        {/* Company Overview */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
          <div className="lg:col-span-7">
            <div className="aspect-[16/9] w-full overflow-hidden border border-white/5 relative group">
              <img 
                src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80&w=1200" 
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 hover:scale-105" 
                alt="Rama Infra Projects" 
              />
              <div className="absolute bottom-4 left-4 bg-black/80 px-3 py-1 text-[8px] bank-gothic tracking-widest accent-text">
                ESTABLISHED 2000
              </div>
            </div>
          </div>
          <div className="lg:col-span-5 space-y-6">
            <span className="bank-gothic text-[9px] text-[#c49b66] tracking-[0.3em] block">COMPANY OVERVIEW</span>
            <h4 className="bank-gothic text-2xl text-white leading-tight">Building Infrastructure <span className="accent-text">Across India</span></h4>
            <p className="text-xs md:text-sm text-neutral-400 font-light leading-relaxed">
              Established on 7th March 2000, Rama Infra Projects specializes in infrastructure, construction, interiors, modernization, and turnkey project execution across India.
            </p>
            <p className="text-xs text-neutral-400 font-light leading-relaxed">
              We deliver comprehensive solutions for government institutions, public sector undertakings, and corporate clients, ensuring quality, timely delivery, and excellence in every project we undertake.
            </p>
          </div>
        </div>

        {/* Vision & Mission */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-16 border-t border-b border-white/5 py-24 bg-[#111]/30 px-6">
          <div>
            <span className="bank-gothic text-[9px] text-neutral-500 tracking-widest block mb-4">OUR VISION</span>
            <h4 className="bank-gothic text-xl text-white mb-6">Excellence in Infrastructure</h4>
            <p className="text-xs text-neutral-400 font-light leading-relaxed mb-4">
              To be the most trusted and preferred infrastructure development partner in India, known for delivering innovative, sustainable, and high-quality projects that exceed client expectations.
            </p>
            <p className="text-xs text-neutral-400 font-light leading-relaxed">
              We strive to set new benchmarks in construction excellence through continuous improvement, technological advancement, and unwavering commitment to safety and quality.
            </p>
          </div>
          <div className="border-t md:border-t-0 md:border-l border-white/5 pt-12 md:pt-0 md:pl-16">
            <span className="bank-gothic text-[9px] text-neutral-500 tracking-widest block mb-4">OUR MISSION</span>
            <h4 className="bank-gothic text-xl text-white mb-6">Building Tomorrow's Infrastructure</h4>
            <p className="text-xs text-neutral-400 font-light leading-relaxed mb-4">
              To deliver turnkey infrastructure solutions that combine innovative design, superior quality, and timely execution while maintaining the highest standards of professionalism and integrity.
            </p>
            <p className="text-xs text-neutral-400 font-light leading-relaxed">
              We are committed to sustainable practices, fostering long-term relationships with our clients, and contributing to India's infrastructure development.
            </p>
          </div>
        </div>

        {/* In-House Design Team */}
        <div className="mb-16 border-b border-white/5 pb-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
            <div className="lg:col-span-5">
              <span className="bank-gothic text-[9px] text-[#c49b66] tracking-[0.3em] block mb-4">CAPABILITIES</span>
              <h4 className="bank-gothic text-2xl text-white mb-6 leading-tight">Dedicated Design & Planning Division</h4>
              <p className="text-xs text-neutral-400 font-light leading-relaxed mb-4">
                Our in-house design team comprises experienced architects, structural engineers, and project planners who work collaboratively to deliver innovative and practical solutions.
              </p>
              <p className="text-xs text-neutral-400 font-light leading-relaxed">
                From conceptual design to detailed engineering, our integrated approach ensures seamless coordination, quality control, and timely project delivery.
              </p>
            </div>
            <div className="lg:col-span-7">
              <div className="grid grid-cols-2 gap-6">
                <div className="border border-white/5 p-6 bg-[#111]/50">
                  <div className="accent-text bank-gothic text-3xl mb-3">15+</div>
                  <h5 className="bank-gothic text-[10px] text-white tracking-widest">ARCHITECTS</h5>
                </div>
                <div className="border border-white/5 p-6 bg-[#111]/50">
                  <div className="accent-text bank-gothic text-3xl mb-3">20+</div>
                  <h5 className="bank-gothic text-[10px] text-white tracking-widest">ENGINEERS</h5>
                </div>
                <div className="border border-white/5 p-6 bg-[#111]/50">
                  <div className="accent-text bank-gothic text-3xl mb-3">10+</div>
                  <h5 className="bank-gothic text-[10px] text-white tracking-widest">PLANNERS</h5>
                </div>
                <div className="border border-white/5 p-6 bg-[#111]/50">
                  <div className="accent-text bank-gothic text-3xl mb-3">24/7</div>
                  <h5 className="bank-gothic text-[10px] text-white tracking-widest">SUPPORT</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Leadership */}
        <div>
          <div className="mb-16">
            <h4 className="bank-gothic text-xs text-neutral-500 tracking-[0.3em] mb-4 uppercase">LEADERSHIP</h4>
            <h3 className="bank-gothic text-3xl">
              MANAGEMENT <span className="accent-text">TEAM</span>
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="border border-white/5 p-8 md:p-10 bg-gradient-to-br from-[#111]/80 to-black relative overflow-hidden">
              <div className="absolute top-0 left-0 h-px w-20 accent-bg opacity-80"></div>
              <div className="accent-text bank-gothic text-4xl leading-none mb-6">01</div>
              <h4 className="bank-gothic text-sm text-white mb-2 leading-relaxed">UMASHANKAR PARMANAND MISHRA</h4>
              <p className="accent-text bank-gothic text-[9px] tracking-widest mb-5">DIRECTOR</p>
              <p className="text-xs text-neutral-300 leading-relaxed italic">
                "Building strong foundations through integrity, quality, and long-term vision."
              </p>
            </div>
            <div className="border border-white/5 p-8 md:p-10 bg-gradient-to-br from-[#111]/80 to-black relative overflow-hidden">
              <div className="absolute top-0 left-0 h-px w-20 accent-bg opacity-80"></div>
              <div className="accent-text bank-gothic text-4xl leading-none mb-6">02</div>
              <h4 className="bank-gothic text-sm text-white mb-2 leading-relaxed">VANDANA UMASHANKAR MISHRA</h4>
              <p className="accent-text bank-gothic text-[9px] tracking-widest mb-5">DIRECTOR</p>
              <p className="text-xs text-neutral-300 leading-relaxed italic">
                "Success is achieved when commitment meets consistency in every endeavor."
              </p>
            </div>
            <div className="border border-white/5 p-8 md:p-10 bg-gradient-to-br from-[#111]/80 to-black relative overflow-hidden">
              <div className="absolute top-0 left-0 h-px w-20 accent-bg opacity-80"></div>
              <div className="accent-text bank-gothic text-4xl leading-none mb-6">03</div>
              <h4 className="bank-gothic text-sm text-white mb-2 leading-relaxed">DIPTANSHU UMASHANKAR MISHRA</h4>
              <p className="accent-text bank-gothic text-[9px] tracking-widest mb-5">DIRECTOR</p>
              <p className="text-xs text-neutral-300 leading-relaxed italic">
                "Innovation and adaptability are the driving forces behind sustainable growth."
              </p>
            </div>
            <div className="border border-white/5 p-8 md:p-10 bg-gradient-to-br from-[#111]/80 to-black relative overflow-hidden">
              <div className="absolute top-0 left-0 h-px w-20 accent-bg opacity-80"></div>
              <div className="accent-text bank-gothic text-4xl leading-none mb-6">04</div>
              <h4 className="bank-gothic text-sm text-white mb-2 leading-relaxed">RUDRANSH UMASHANKAR MISHRA</h4>
              <p className="accent-text bank-gothic text-[9px] tracking-widest mb-5">DIRECTOR</p>
              <p className="text-xs text-neutral-300 leading-relaxed italic">
                "The future belongs to those who combine ambition with purposeful action."
              </p>
            </div>
          </div>
        </div>


      </div>
    </div>
  );
}

export default AboutPageNew;
